/**
 * FunnelRuntimeContext
 *
 * React context for the funnel runtime. Separated from the provider
 * to satisfy react-refresh/only-export-components lint rule.
 */

import { createContext } from 'react'
import type { FunnelRuntimeContextValue } from './funnel-runtime.types'

export const FunnelRuntimeContext = createContext<FunnelRuntimeContextValue | undefined>(undefined)
